import React, { FunctionComponent, useEffect } from 'react'
import { useMatch, useNavigate } from 'react-router'
import { Route, Routes } from 'react-router-dom'
import RouteTabLink from '../Tab/RouteTabLink'
import { Import } from './Import'
import ServiceProviders from './ServiceProviders'

interface Props {
  teamID: string
}

const Support: FunctionComponent<Props> = props => {
  const navigateTo = useNavigate()
  const match = useMatch('/support/:subPath')
  useEffect(() => {
    if (!match) {
      navigateTo('/support/invite-service-provider')
    }
  }, [match, navigateTo])

  return (
    <div className='tab'>
      <header className=''>
        <div className='auto'>
          <h2>Support</h2>
        </div>
        <div className='tabs'>
          <ul className='auto'>
            <RouteTabLink key='/support/invite-service-provider' path='/support/invite-service-provider'>
              Invite a service provider
            </RouteTabLink>
            <RouteTabLink key='/support/import' path='/support/import'>
              Import a PMITC org instance
            </RouteTabLink>
          </ul>
        </div>
      </header>
      <div className='tab auto'>
        <Routes>
          <Route key='/import' path='/import' element={<Import />} />
          <Route
            key='/invite-service-provider'
            path='/invite-service-provider'
            element={<ServiceProviders teamID={props.teamID} />}
          />
        </Routes>
      </div>
    </div>
  )
}

export default Support
